import { getGlossaryListBySlug } from '../../../lib/contentful';
import { glossaryListType } from '../../../humanity/components/glossaryList/glossaryList.types';

import { pageSettingsType } from 'types/pages/pageContainer.types';
import {
  RetirementGlossary,
  retirementGlossaryFragment,
  retirementGlossaryType,
} from 'humanity/pages/retirementGlossary';
import { PageContainer } from 'humanity/pages/pageContainer';
import { getPageContainerBySlug, getPageSettingsBySlug } from 'lib/contentful';
import { serverLogger } from 'utils/serverLogger';

export const RETIREMENT_GLOSSARY_SLUG = 'learn/retirement-glossary';

const RetirementGlossaryPage = ({ pageSettings, pageContent, glossaryList }) => (
  <PageContainer
    layout={pageSettings.layout}
    notes={pageContent.notesCollection?.items}
    disclosures={pageContent.disclosuresCollection?.items}
    seoMetadata={pageSettings.seoMetadata}
  >
    <RetirementGlossary
      sections={pageContent.page.sectionsCollection?.items}
      glossaryList={glossaryList}
    />
  </PageContainer>
);

RetirementGlossaryPage.propTypes = {
  pageSettings: pageSettingsType.isRequired,
  pageContent: retirementGlossaryType.isRequired,
  glossaryList: glossaryListType.isRequired,
};

export const getStaticProps = async ({ preview = true }) => {
  try {
    const [pageSettings, pageContent, glossaryList] = await Promise.all([
      getPageSettingsBySlug(RETIREMENT_GLOSSARY_SLUG, preview),
      getPageContainerBySlug(
        RETIREMENT_GLOSSARY_SLUG,
        retirementGlossaryFragment,
        preview
      ),
      getGlossaryListBySlug(RETIREMENT_GLOSSARY_SLUG, preview),
    ]);

    if (!pageSettings || !pageContent) return { notFound: true };

    return { props: { pageSettings, pageContent, glossaryList }, revalidate: 900 };
  } catch (err) {
    serverLogger.error(
      `Error fetching page with slug ${RETIREMENT_GLOSSARY_SLUG}`,
      err,
      err.response?.data
    );
    throw new Error(`Error fetching page with slug ${RETIREMENT_GLOSSARY_SLUG}`, {
      cause: err,
    });
  }
};

export default RetirementGlossaryPage;
